import { Platform, PLATFORMS } from '.'
import okbetLogo from '@/assets/okbet.png'
import okfunLogo from '@/assets/okfun.png'

// 商所邏輯統一放這裡管理，避免漏改

// 登入頁 logo
export const getPlatformLogo = () => {
  if (Platform.PLATFORM === PLATFORMS.OKFUN) return okfunLogo
  return okbetLogo
}
